/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';

import { DataQuery } from '@typescript-kit/data';
import { HttpService } from '@angular-kit/core';

import { DeleteProjectDto, Project, ProjectData } from '@teamworks/global';

@Injectable()
export class ProjectService {

  constructor(private httpService: HttpService) {
  }

  async loadProjectList(dataQuery?: DataQuery): Promise<Project[]> {
    return this.httpService.get(`api/base-data/project-list`, { 'data-query': dataQuery })
      .then((loadedData: ProjectData[]) => loadedData.map(data => new Project(data)));
  }

  async loadProject(id: string, dataQuery?: DataQuery): Promise<Project> {
    return this.httpService.get(`api/base-data/project/${id}`, { 'data-query': dataQuery })
      .then((loadedData: ProjectData) => loadedData && new Project(loadedData));
  }

  async createProject(): Promise<Project> {
    return this.httpService.post(`api/base-data/project`)
      .then((savedData: ProjectData) => new Project(savedData));
  }

  async saveProject(data: ProjectData): Promise<Project> {
    return this.httpService.post(`api/base-data/project`, data)
      .then((savedData: ProjectData) => new Project(savedData));
  }

  async deleteProject(id: string, data: DeleteProjectDto): Promise<Project> {
    return this.httpService.post(`api/base-data/project/${id}/delete`, data)
      .then((deletedData: ProjectData) => new Project(deletedData));
  }
}
